module.exports = __webpack_public_path__ + "img/hotel-19.0809ee04.jpeg";